import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'pagerIndex', 'pagerLength']
  static values = {
    index: { type: Number, default: 0 }
  }

  next () {
    this.indexValue >= this.slideTargets.length - 1 ? (this.indexValue = 0) : this.indexValue++
  }

  previous () {
    this.indexValue === 0 ? (this.indexValue = this.slideTargets.length - 1) : this.indexValue--
  }

  showCurrentSlide () {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle('hidden', this.indexValue !== i)
    })

    if (this.hasPagerIndexTarget && this.slideTargets.length > 1) {
      this.pagerIndexTarget.innerHTML = this.indexValue + 1
    }
  }

  pauseEmbeddedVideos () {
    this.element.querySelectorAll('iframe').forEach(iframe => {
      if (iframe.src.includes('youtube')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
      } else if (iframe.src.includes('vimeo')) {
        iframe.contentWindow.postMessage('{"method": "pause"}', '*')
      }
    })
  }

  indexValueChanged () {
    this.showCurrentSlide()
    this.pauseEmbeddedVideos()
  }
}
